// action - state management
import {
  ADMIN_LOADED,
  AUTH_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  token: localStorage.getItem("ownerAppToken"),
  isAuthenticated: false,
  loading: true,
  admin: {},

  role: "owner",
};

// const accountReducer = (state = initialState, action) => {
export default function accountReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_SUCCESS:
      localStorage.setItem("ownerAppToken", payload.token);
      localStorage.setItem("role", "owner");

      return {
        ...state,
        admin: payload.admin_staff,
        isAuthenticated: true,
        loading: false,
        role: "owner",
      };
    case ADMIN_LOADED:
      // localStorage.setItem("role", JSON.stringify("user"));
      localStorage.setItem("role", JSON.stringify("owner"));
      localStorage.setItem("ownerId", payload.owner._id);
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        admin: payload.owner,
        role: "owner",
      };
    case LOGOUT_SUCCESS:
      localStorage.removeItem("ownerAppToken");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    case AUTH_FAIL:
      localStorage.removeItem("ownerAppToken");
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    default:
      return state;
  }
}

// export default accountReducer;
